module.exports = {
      id: "google-usage",
      viewBox: "0 0 533.5 544.3",
      url: __webpack_public_path__ + "svg-sprite-cba8a2d7d36c4565ac7b4e175a8fc907.svg#google",
      toString: function () {
        return this.url;
      }
    }